import { getI18n } from "./i18n";

export function formatTermLength(item) {
  return item.monthlyBilling ? "Mensuel" : getI18n().global.t(`termLength.${item.termLength}_year`);
}
